export const GET_PROPERTIES_FULL_LIST = 'GET_PROPERTIES_FULL_LIST'
export const GET_PROPERTY_BY_KEY = 'GET_PROPERTY_BY_KEY'
export const GET_PROPERTY_PHOTOS = 'GET_PROPERTY_PHOTOS'
export const GET_PROPERTY_CONTACTS = 'GET_PROPERTY_CONTACTS'
export const UPDATE_PROPERTY = 'UPDATE_PROPERTY'
